import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { useState, useCallback, Fragment } from "react";
import { componentStyles } from "./select-input.scss";
import { commonInputStyles } from "../common-inputs.scss";
import { withGenericConfig } from "/contexts/generic-config-context";
import classnames from "classnames";
import FloatingLabelWrapper from "../floating-label-wrapper/floating-label-wrapper";
function SelectInputFloatingLabel(props) {
    const { inputData, errorState, value, invalid, errorLabelId, id, translate } = props;
    const { inputName, isRequired, options, defaultValue, placeholder } = inputData;
    const { isValid } = errorState;
    const [isFocused, setIsFocused] = useState(false);
    const [hasValue, setHasValue] = useState(!!value);
    const handleFocus = useCallback(()=>{
        setIsFocused(true);
    }, []);
    const handleBlur = useCallback((e)=>{
        const { onInputBlur } = props;
        setIsFocused(false);
        setHasValue(!!e.target.value);
        if (onInputBlur) {
            onInputBlur(e);
        }
    }, [
        props
    ]);
    const handleChange = useCallback((e)=>{
        const { onInputChange } = props;
        setHasValue(!!e.target.value);
        if (onInputChange) {
            onInputChange(e);
        }
    }, [
        props
    ]);
    const renderOptions = ()=>{
        const optionsToRender = options.map((option)=>/*#__PURE__*/ _jsx("option", {
                className: "contact-form-row",
                value: option,
                name: option,
                children: translate(option)
            }, option));
        return /*#__PURE__*/ _jsxs(Fragment, {
            children: [
                /*#__PURE__*/ _jsx("option", {
                    value: "",
                    disabled: true
                }),
                optionsToRender
            ]
        });
    };
    const showRequiredError = !isValid && isRequired;
    const requiredClass = {
        "input-required": showRequiredError
    };
    const translatedPlaceholder = translate(placeholder || defaultValue);
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FloatingLabelWrapper, {
                label: translatedPlaceholder,
                htmlFor: id,
                isFocused: isFocused,
                hasValue: hasValue || !!value,
                variant: "select",
                children: /*#__PURE__*/ _jsx("select", {
                    id: id,
                    onChange: handleChange,
                    onFocus: handleFocus,
                    onBlur: handleBlur,
                    name: inputName,
                    value: value || "",
                    "aria-label": translatedPlaceholder,
                    "aria-required": isRequired,
                    "aria-invalid": invalid,
                    "aria-describedby": errorLabelId,
                    className: `jsx-${componentStyles.__hash} jsx-${commonInputStyles.__hash}` + " " + (classnames("hp-input hp-select-input", requiredClass) || ""),
                    children: renderOptions()
                })
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: commonInputStyles.__hash,
                children: commonInputStyles
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: componentStyles.__hash,
                children: componentStyles
            })
        ]
    });
}
SelectInputFloatingLabel.defaultProps = {
    invalid: false,
    errorLabelId: null
};
export default withGenericConfig(SelectInputFloatingLabel);
